{
  "action": "Action: ",
  "actionName": "Action",
  "activeDatesLabel": "Dates actives",
  "activeDatesValueWithStartAndEnd": "{{start, datetime}} - {{end, datetime}}",
  "activeDatesWithStart": "{{start, datetime}}",
  "cancel": "Annuler",
  "datetimeWithVal": "{{val, datetime}}",
  "delete": "Supprimer",
  "deleteThisSchedule": "Supprimer ce planning ?",
  "endTimeLabel": "Fin",
  "executeAt": "Exécuter à",
  "executeAtWithTimestamp": "{{timestamp, datetime}}",
  "executeOnceOn": "Exécuter une fois sur :",
  "executeOnceOnWithDate": "Exécuter une fois le {{val, datetime}}",
  "executionTime": "Délai d'exécution",
  "executionWithStartAndEnd": "{{start, datetime}} - {{end, datetime}}",
  "executionWithStartAndEndAndTimezone": "{{start, datetime}} - {{end, datetime}} {{timezone}}",
  "executionWithStartAndEndAndTimezoneNextDay": "{{start, datetime}} - {{end, datetime}} {{timezone}} (jour suivant)",
  "executionWithStartAndEndNextDay": "{{start, datetime}} - {{end, datetime}} (jour suivant)",
  "executionWithStartNextDay": "{{start, datetime}} (jour suivant)",
  "helpBody": "Les programmes sont utilisés pour allumer et éteindre les pompes ou les vannes à des heures précises ou pour des durées spécifiques. Les programmes peuvent être configurés pour s'exécuter une fois ou pour se répéter certains jours de la semaine.\n\nLes programmes doivent être synchronisés avec les appareils pour fonctionner correctement, ce qui devrait se produire rapidement, mais pas immédiatement. Si vous ne voyez pas votre programme s'exécuter au moment prévu, veuillez vérifier l'état de synchronisation. Si l'état de synchronisation est « Synchronisation échouée », veuillez contacter le support FarmHQ.",
  "helpTitle": "À propos des horaires",
  "manageScheduleTitle": "Gérer le planning",
  "new": "Nouveau",
  "nextDayParentheses": "(Lendemain)",
  "nextScheduleActionWithTimestamp": "Prochaine action prévue à {{timestamp, datetime}}",
  "noSchedules": "Aucune action planifiée trouvée pour votre compte de ferme.",
  "noSchedulesActive": "Aucun horaire actif trouvé.",
  "noSchedulesExpired": "Aucune action planifiée passée n'a été trouvée.",
  "repeatWeeklyOnDays": "Répéter chaque semaine les jours suivants :",
  "repeats": "Répétitions :",
  "scheduledActions": "Actions planifiées",
  "schedulesActiveTitle": "Horaires actifs",
  "schedulesExpiredTitle": "Horaires expirés",
  "schedulesListTitle": "Programmes d'irrigation",
  "startTimeLabel": "Commencer",
  "status": "Statut",
  "syncStatus_FAILED": "La synchronisation a échoué. Veuillez contacter le support.",
  "syncStatus_IN_PROGRESS": "Synchronisation avec l'appareil...",
  "syncStatus_SUCCESS": "Synchronisé avec l'appareil.",
  "theFollowingScheduledActionWillBeCancelled": "L’action planifiée suivante sera annulée.",
  "thisWeek": "Cette semaine:",
  "time": "Temps"
}
